import cookie from "@utils/store/cookie";
const LOGIN_KEY = "login_status";

const state = {
  footer: true,
  home: true,
  homeActive: false,
  token: cookie.get(LOGIN_KEY) || null,
  roleid: null,
  subscribe: null,
  prj_code: '',
  FileRoot: '',
  backgroundColor: "#fff",
};
const mutations = {
  SHOW_FOOTER(state) {
    state.footer = true;
  },
  HIDE_FOOTER(state) {
    state.footer = false;
  },
  SHOW_HOME(state) {
    state.home = true;
  },
  HIDE_HOME(state) {
    state.home = false;
  },
  OPEN_HOME(state) {
    state.homeActive = true;
  },
  CLOSE_HOME(state) {
    state.homeActive = false;
  },
  LOGIN(state, data, express_days) {
    console.log('state login', data, express_days)
    state.auth = 1;
    state.token = data.openid;
    state.subscribe = +data.subscribe;
    state.roleid = +data.roleid;

    cookie.set(LOGIN_KEY, state.token, express_days);
  },
  setPrjCode(state, prj_code) {
	  console.log('setPrjCode', prj_code)
    state.prj_code = prj_code
  },
  setAppData(state, data, express_days) {
    express_days = express_days || 7
    console.log('setAppData', data, express_days)
    state.token = data.openid;
    state.subscribe = +data.subscribe;
    state.roleid = +data.roleid;
    state.prj_code = data.prjcode;
    state.FileRoot = data.prj_pic_src;
    cookie.set(LOGIN_KEY, state.token, express_days);
  },
  LOGOUT(state) {
    state.auth = 0;
    state.token = null;
    state.roleid = null;
    state.subscribe = null;
    cookie.remove(LOGIN_KEY);
  },
  BACKGROUND_COLOR(state, color) {
    state.color = color;
    document.body.style.backgroundColor = color;
  },
};

const actions = {

};
const getters = {
  getFileRoot(context) {
    return context.FileRoot
  }
}

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/app.js